import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}
const CHECKOUT_URL = 'https://ct84qv-hx.myshopify.com/checkouts/cn/hWN9cfG5D2A7HQiUQfwQOjMQ/es-ar';
export function CTAButton({
  children,
  className = '',
  onClick
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    // Prevent duplicate fires
    e.stopPropagation();
    // Fire Meta Pixel InitiateCheckout event (once)
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('trackSingle', '1303917948224437', 'InitiateCheckout');
    }
    onClick?.();
  };
  return <motion.a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`inline-block text-center bg-amber text-charcoal-900 font-bold py-4 px-8 sm:px-12 text-lg sm:text-xl rounded-sm animate-pulse-glow transition-colors hover:bg-amber-hover uppercase tracking-wider cursor-pointer ${className}`} data-id="element-171">
      {children}
    </motion.a>;
}